import React, { useState, useRef } from "react";
import useOnClickOutside from "./hooks";

function RoomSelect(props) {
    const ref = useRef();
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const rates = [{ id: 0, name: "Любой" }];
    Array.prototype.push.apply(rates, props.rates);
    let rateName = rates.filter((item) => {
        if (item.id === props.rateId) {
            return true;
        }
        return false;
    });
    rateName = rateName.length > 0 ? rateName[0].name : rates[0].name;

    const onRoomSelect = (newLabel, newValue) => {
        setDropdownOpen(false);
        props.onRateChange(newValue);
    };

    const select = rates.map((val, idx) => (
        <div
            key={idx}
            className="dropdown-wrapper__item"
            onClick={() => onRoomSelect(val.name, val.id)}
        >
            {val.name}
        </div>
    ));

    useOnClickOutside(ref, () => setDropdownOpen(false));

    return (
        <div
            className={`search-form__input-number${isDropdownOpen ? " active" : ""}`}
            ref={ref}
        >
            <div onClick={() => setDropdownOpen(true)}>
                <div className="title">Тариф</div>
                <div className="content">{rateName}</div>
            </div>
            <div className="dropdown-wrapper__number">
                <div className="dropdown-wrapper__list">{select}</div>
            </div>
        </div>
    );
}

export default RoomSelect;
